import axios from 'axios';
import { setupHttpClient } from '@clickersphere/core/services/helper/httpClient';

setupHttpClient({
  baseURL: '/api',
  withCredentials: true,
  refreshSession: async () => {
    await axios.post('/api/auth/refresh-session', null, {
      withCredentials: true,
    });
  },
  onForceLogout: () => {
    window.dispatchEvent(new Event('logoutEvent'));
  },
});
